var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTinyHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.533C7.8 14.533 7.66667 14.4663 7.53334 14.333L1.93334 8.73301C1.13334 7.93301 0.666672 6.79967 0.666672 5.66634C0.666672 3.26634 2.60001 1.33301 5 1.33301C6.33334 1.33301 7.33334 2.06634 8 2.99967C8.66667 2.06634 9.66667 1.33301 11 1.33301C13.4 1.33301 15.3333 3.26634 15.3333 5.66634C15.3333 6.86634 14.7333 8.06634 13.6667 9.13301L8.46667 14.2663C8.33334 14.4663 8.13334 14.533 8 14.533ZM5 2.66634C3.33334 2.66634 2.00001 3.99967 2.00001 5.66634C2.00001 6.46634 2.33334 7.19967 2.86667 7.79967L8 12.933L12.7333 8.26634C13.6 7.39967 14.0667 6.53301 14.0667 5.73301C14 3.99967 12.6667 2.66634 11 2.66634C9.86667 2.66634 9 3.66634 8.6 4.59967C8.46667 4.86634 8.26667 4.99967 8 4.99967C7.73334 4.99967 7.46667 4.86634 7.4 4.59967C7 3.66634 6.13334 2.66634 5 2.66634Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinyHeart);
export default __webpack_public_path__ + "static/media/tinyHeart.28d7cedec2927c0a02ea6f17561267c2.svg";
export { ForwardRef as ReactComponent };